/* eslint-disable react/display-name */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React, { memo } from 'react';
import { Flex, Text, Box } from '@chakra-ui/core';
import { FaCheck } from 'react-icons/fa';
import { MismatchBadge } from '../components/MismatchBadge';
import colors from '../../../../../../styles/colors';

interface DayCellProps {
  dayLabel: string;
  isDayRequired: boolean;
  isMismatch?: boolean;
  hasData?: boolean;
}

export const DayCell = memo(({ dayLabel, isDayRequired, isMismatch, hasData }: DayCellProps) => (
  <Box minWidth="65px" data-testid="day-cell">
    <Flex align="center" justify="space-between" width="100%" gridGap="4px">
      <Flex align="center" gridGap="4px">
        <Text
          fontSize="13px"
          ml={1}
          fontWeight={hasData ? 700 : 400}
          data-testid="day-cell-label"
          style={{ fontWeight: hasData ? 700 : 400 }}
        >
          {dayLabel}
        </Text>
        {isDayRequired && (
          <Box data-testid="day-cell-check">
            <FaCheck size={11} color={colors.gray[450]} />
          </Box>
        )}
      </Flex>
      {isMismatch && <MismatchBadge data-testid="day-cell-mismatch" />}
    </Flex>
  </Box>
));

DayCell.displayName = 'DayCell';
